import React from 'react'
import {LayoutChild} from "../../../../palette/Palette";
import PieChart, {
    Series,
    Label,
    Connector,
    SmallValuesGrouping,
    Legend,
    Export
} from 'devextreme-react/pie-chart';
import Alerts from "../../../../palette/Alerts";


function RouteTrend(props) {

    const {routeTrend} = props;

    return (
        <>
            {routeTrend?.length > 0 ?
                <LayoutChild percent={100} padding={10}>
                    <PieChart
                        id="pie"
                        dataSource={routeTrend}
                        palette="Bright"
                        title="Tendencia de uso rutas trimestral"
                    >
                        <Series
                            argumentField="routeName"
                            valueField="percent"
                        >
                            <Label visible={true} customizeText={formatLabel} format="fixedPoint">
                                <Connector visible={true} width={0.5}/>
                            </Label>
                            <SmallValuesGrouping threshold={4.5} mode="smallValueThreshold"/>
                        </Series>
                        <Legend horizontalAlignment="center" verticalAlignment="bottom"/>
                        <Export enabled={true}/>
                    </PieChart>
                </LayoutChild> :
                <div style={{marginTop: 10,  padding: 5}}>
                    <Alerts severity="warning" body={'Aún no existen rutas.'}/>
                </div>}
        </>
    )
}

function formatLabel(arg)
{
    return `${arg.argumentText}: ${arg.valueText}%`;
}


export default RouteTrend